module.exports = __webpack_public_path__ + "img/SELFEE.fdd9e08c.png";